<template>
  <div class="section section_confirmations">
    <div class="main_container step_1_form main_container_fixed">
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6">
          <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
          <h1 class="heading-3">{{$t('FULLFILL_DETAILS_CONTACT')}}</h1>
        </div>
        <div class="column-16 w-col w-col-3"></div>
      </div>
      <div class="sub_container w-form">
        <validation-observer v-slot="{ handleSubmit, reset }">
          <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" id="email-form" name="email-form" data-name="Email Form" class="main_form stepform_1">
            <div class="w-layout-grid grid-8">
              <div id="w-node-c7f45c46-c7ec-24c6-7a7c-8228eb2f7b3e-a83646e0" class="form_field">
                <validation-provider  :name="$t('ΝΑΜΕ')" rules="required" v-slot="{ errors, classes }">
                  <div class="form_columns w-row">
                    <div class="column-4 w-clearfix w-col w-col-4"><label for="email" class="field_label">{{$t('ΝΑΜΕ')}}</label></div>
                    <div class="column-13 w-col w-col-8"></div>
                  </div>
                  <input v-model="NAME" type="text" class="text_field_input text-field w-input" maxlength="256" name="name-2" id="name-2" />
                  <span :class="classes">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div id="w-node-_54c34e72-060b-7058-03b8-c840fc84ba6d-a83646e0" class="form_field">
                <validation-provider  :name="$t('PHONE')" rules="required" v-slot="{ errors, classes }">
                  <div class="form_columns w-row">
                    <div class="column-4 w-clearfix w-col w-col-4"><label for="email" class="field_label">{{$t('PHONE')}}</label></div>
                    <div class="column-13 w-col w-col-8"></div>
                  </div>
                  <cleave-phone v-model="PHONE" type="text" class="text_field_input text-field w-input" maxlength="256" name="name-2" id="name-2" ></cleave-phone>
                  <span :class="classes">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div id="w-node-d221c781-86af-7027-d4d7-b6efb77373ff-a83646e0" class="form_field">
                <button type="submit" class="submit-button submit-button-2 main_button w-button">{{$t('VALIDATE')}}</button>
                <div class="form_columns split_form_columns w-row">
                  <div class="field_column w-col w-col-6"></div>
                  <div class="column-12 w-col w-col-6"></div>
                </div>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      NAME: '',
      PHONE: ''
    };
  },
  methods: {
    submitForm() {
      this.$router.push({ path: '/' });
    }
  }
};
</script>
